import { Box, Heading, Stack, Text } from 'braid-design-system';
import { HirerNotificationPreferenceProvider } from '@seek/hirer-notification-preference';

import hirerGraphqlClient from 'src/graphql/hirer/client';
import type { IJob } from 'src/stores/JobStore/Job';
import { NotificationPreferenceFormSection } from '../NotificationPreferenceFormSection';
import { JobIsExpiredView } from '../JobIsExpiredView';

import { useTranslations } from '@vocab/react';
import translations from '../.vocab';
export interface NotificationPreferenceProps {
  onSubmitSuccess: () => void;
  onCancel: () => void;
  onReturnToJob: () => void;
  seekAdvertiserId: string;
  job: IJob;
}

const NotificationPreference = ({
  onSubmitSuccess,
  onCancel,
  onReturnToJob,
  seekAdvertiserId,
  job,
}: NotificationPreferenceProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box padding="large" width="full">
      {job.isExpired ? (
        <JobIsExpiredView onClick={onReturnToJob} />
      ) : (
        <Stack space="medium">
          <Text>
            <Heading level="3">
              {t(
                'Choose how often we notify you about new applications for title',
                { title: job.jobInformation.title },
              )}
            </Heading>
          </Text>
          <Box padding="large">
            <HirerNotificationPreferenceProvider
              jobId={`${job.jobInformation.jobId}`}
              seekAdvertiserId={seekAdvertiserId}
              currentLoginUserId={`${job.userStore.user.userId}`}
              currentLoginUserEmail={`${job.userStore.user.email}`}
              apolloClient={hirerGraphqlClient}
            >
              <NotificationPreferenceFormSection
                onSubmitSuccess={onSubmitSuccess}
                onCancel={onCancel}
              />
            </HirerNotificationPreferenceProvider>
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default NotificationPreference;
